import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function AdminThreadModal({
  show,
  onHide,
  adminMessages
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Messages with Admin</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: 350, overflowY: 'auto' }}>
        {Array.isArray(adminMessages) && adminMessages.length === 0 ? (
          <div className="text-muted">No messages with admin yet.</div>
        ) : (
          <ul style={{ listStyle: "none", padding: 0 }}>
            {Array.isArray(adminMessages) && adminMessages
              .filter(msg => msg && (msg.text || msg.message))
              .map((msg, i) => (
                <li key={i} style={{ marginBottom: 10 }}>
                  <b>{msg.from === "admin" ? "Admin" : "You"}</b>: {msg.text || msg.message}
                  <br />
                  <span className="text-secondary" style={{ fontSize: 12 }}>
                    {msg.date
                      ? (typeof msg.date === "string"
                          ? new Date(msg.date).toLocaleString()
                          : msg.date.toString())
                      : ""}
                  </span>
                </li>
            ))}
          </ul>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
